import { createBaseExportSchema } from '@app/modules/social-export/components/validation/useBaseExportSchema';
import { useMemo } from 'react';
import { IntlFormatters, useIntl } from 'react-intl';
import { z } from 'zod';

const DEMO_DESCRIPTION_MAX_LENGTH = 5000;

/** Builds the Zod schema for the Demo platform publish form. */
export function createDemoPublishSchema(t: IntlFormatters['$t']) {
  return createBaseExportSchema(t).extend({
    title: z.string().trim().min(1),
    description: z.string().trim().min(1).max(DEMO_DESCRIPTION_MAX_LENGTH),
  });
}

export type DemoPublishValues = z.infer<ReturnType<typeof createDemoPublishSchema>>;

/** Zod schema for the Demo publish form with translated validation messages. */
export function useDemoPublishSchema() {
  const { $t } = useIntl();
  return useMemo(() => createDemoPublishSchema($t), [$t]);
}
